__turbopack_context__.v({
  "header": "_03_Z4G_header",
  "label": "_03_Z4G_label",
  "platformLogo": "_03_Z4G_platformLogo",
  "platformLogos": "_03_Z4G_platformLogos",
  "platformMore": "_03_Z4G_platformMore",
  "platformSection": "_03_Z4G_platformSection",
  "platformText": "_03_Z4G_platformText",
  "section": "_03_Z4G_section",
  "step": "_03_Z4G_step",
  "stepArrow": "_03_Z4G_stepArrow",
  "stepContent": "_03_Z4G_stepContent",
  "stepDesc": "_03_Z4G_stepDesc",
  "stepNumber": "_03_Z4G_stepNumber",
  "stepTitle": "_03_Z4G_stepTitle",
  "steps": "_03_Z4G_steps",
  "title": "_03_Z4G_title",
});
